export const scrubbingCenter = [
  {
    title: "حملات تزریق کد",
    desc: "حملاتی مانند SQL Injection و XSS که سعی در اجرای کدهای مخرب در اپلیکیشن دارند، با دقت بالا شناسایی و مسدود می‌شوند.",
  },
  {
    title: "حملات حجمی و فایل‌محور",
    desc: "حملات DoS و DDoS که منابع سیستم را هدف می‌گیرند، و RFI و LFI که از آسیب‌پذیری‌های کدنویسی ناشی می‌شوند، با الگوریتم‌های هوشمند دفع می‌شوند.",
  },
  {
    title: "بات‌ها و درخواست‌های مشکوک",
    desc: "درخواست‌هایی که خارج از استانداردهای HTTP هستند یا توسط بات‌ها و اسکنرهای مشکوک ارسال می‌شوند، قبل از رسیدن به اپلیکیشن فیلتر و مسدود می‌شوند",
  },
  {
    title: "تلاش برای دور زدن WAF",
    desc: "الگوهای چند لایه و پیچیده که با هدف عبور از فایروال طراحی شده‌اند، با تحلیل بلادرنگ شناسایی می‌شوند و پیش از ورود به سیستم، با دقت بالا مسدود می‌شوند.",
  },
];

export const firewall = [
  {
    img: "1.svg",
    title: "COMODO",
    title_en: "COMODO",
    desc: "رول‌ستی مطمئن برای مقابله با تهدیدات رایج وب‌اپلیکیشن‌ها است؛ که یک لایه محافظتی پایه ولی حیاتی فراهم می‌کند و در برابر حملات شناخته‌شده امنیتی نقش کلیدی دارد.",
  },

  {
    img: "2.svg",
    title: "OWASP CRS",
    title_en: "OWASP CRS",
    desc: "رول‌ست Core Rule Set با مجموعه‌ای گسترده از قوانین طراحی شده تا حملات امنیتی عمومی را شناسایی کند. این رول‌ست برای مقابله با طیف وسیع‌تری از تهدیدات لایه اپلیکیشن کاربرد دارد.",
  },
  {
    img: "3.svg",
    title: "Abalon Cloud",
    title_en: "Abalon Cloud",
    desc: "رول‌ستی اختصاصی که توسط تیم امنیتی آبالون توسعه داده شده و بر اساس معماری شبکه و عملکرد زیرساخت آبالون بهینه‌سازی شده است. مناسب برای سازمان‌هایی که نیاز به تنظیمات و حفاظت سفارشی دارند.",
  },
];

export const needs = [
  {
    title: "وب‌سایت‌های پر ترافیک",
    cap: "برای مدیریت حملات گسترده و جلوگیری از سوءاستفاده از منابع",
  },
  {
    title: "سازمان‌های حساس به داده",
    cap: "برای محافظت از اطلاعات مالی، درمانی یا محرمانه کاربران",
  },
  {
    title: "اپلیکیشن‌های با کاربران زیاد",
    cap: "برای جلوگیری از سوءاستفاده از فرم‌ها و حملات Injection",
  },
  {
    title: "سرویس‌های سفارشی و API محور",
    cap: "برای تنظیم دقیق WAF متناسب با ساختار خاص یا APIها",
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری امکانات یک دیتاسنتر فیزیکی قوی را روی ابرها فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌‌ترین نیازهای سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "VPS-Service.svg",
    route: "/dedicated-server",
  },

  {
    title: "سرویس کولوکیشن",
    desc: "با سرویس کولوکیشن آبالون، بدون دغدغه تامین برق، کولینگ و پهنای باند، سرورهای سازمان شما در محیطی ایمن، با اتصال مستقیم به شبکه‌ای پرسرعت میزبانی می‌شوند.",
    logo: "ManagedService-Service.svg",
    route: "/colocation",
  },
  {
    title: "خدمات دوآپس",
    desc: "تحت سرویس‌های مدیریت شده، راهکارهای اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزار، طراحی معماری و مهاجرت ابری اجرا می‌شود.",
    logo: "DNS.svg",
    route: "/devops",
  },
];

export const questions = [
  {
    title: "آیا برای استفاده از WAF آبالون نیاز به خرید تجهیزات خاصی هست؟",
    answer:
      "خیر. WAF آبالون یک سرویس ابری است و نیازی به نصب یا نگهداری سخت‌افزار در سمت شما ندارد. همه ‌چیز از طریق پنل مدیریت CDN آبالون در اختیار شما قرار می‌گیرد.",
  },
  {
    title: "چه نوع حملاتی توسط WAF شناسایی و مسدود می‌شوند؟",
    answer:
      "حملاتی از جمله SQL Injection، XSS، DoS، DDoS، RFI، LFI و درخواست‌های مشکوک بات‌ها، همگی توسط WAF آبالون به‌صورت بلادرنگ شناسایی و دفع می‌شوند.",
  },
  {
    title: "تفاوت رول‌ست‌های COMODO، CRS و ABALON چیست؟",
    answer:
      "رول‌ست COMODO برای مقابله با تهدیدات رایج، CRS برای پوشش وسیع‌تر تهدیدات و ABALON برای تنظیمات اختصاصی و پیشرفته توسعه داده شده‌اند. استفاده ترکیبی از هر ۳ رول‌ست، بالاترین سطح امنیت را فراهم می‌کند.",
  },
  {
    title: "آیا می‌توان تنظیمات WAF را برای نیازهای خاص سازمانی سفارشی کرد؟",
    answer:
      "بله. با رول‌ست اختصاصی ABALON می‌توانید تنظیمات امنیتی را به‌صورت دقیق و متناسب با ساختار و نیاز سازمان خود شخصی‌سازی کنید.",
  },
  {
    title: "قابلیت Rate Limit در WAF آبالون چه کاربردی دارد؟",
    answer:
      "با Rate Limit می‌توانید تعداد درخواست‌ها به مسیرهای خاص (مثل صفحات ورود) یا از IPهای خاص را محدود کنید. این قابلیت از سوءاستفاده و حملات DoS جلوگیری کرده و از منابع سیستم محافظت می‌کند.",
  },
];
